var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


// $(".tab_header li").click(function () {
//   $this = $(this);
//   $target = $(this).attr("id");
//   $section = $(this).attr("section");
//   $($section + " .tab_header li.current").removeClass("current");
//   $($this).addClass("current");
//   $($section + " .tab-content").removeClass("show is-draggable");
//   $($section + " .tab_data #" + $target).addClass("show is-draggable");
//   $($section + " .tab_data #" + $target + " .slick-initialized").slick("refresh");
//   window.dispatchEvent(new Event("resize"));
// });



// ICON Slider
$('.autoplay').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  autoplaySpeed: 2000,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        infinite: true,
        slidesToScroll: 1,
      },
    }
  ],
});

// Home page swatch section

customElements.define('abz-custom-swatch',
  class AbzCustomSwatch extends HTMLElement {
    constructor() { super(); }
    
    connectedCallback() {
      this.columnContainer = this.closest('.column__inner');
      if(!this.columnContainer) return;
      this.shopBtn = this.columnContainer.querySelector(`.column__btn > a`);
      this.imageAnchor = this.columnContainer.querySelector(`a[href="${this.dataset.href}"][data-column-image-link]`);
      if(!this.imageAnchor) return;
      this.addEventListener('click', e => {
        this.imageAnchor.parentElement.insertBefore(this.imageAnchor, this.imageAnchor. parentElement.firstChild);
        this.shopBtn && (this.shopBtn.href = this.dataset.href);
        this.parentElement.querySelectorAll('abz-custom-swatch').forEach(swatch => {
          swatch.classList.remove('active');
          this.classList.add('active');
        })
      });
      if (this.parentElement.firstElementChild == this) { this.dispatchEvent(new Event('click')) }
    }
});